import type { ReferenceKind } from './ReferenceMentionNode';

export const KIND_LABEL: Record<ReferenceKind, string> = {
    video: 'Video',
    template: 'Template',
    blueprint: 'Blueprint',
    'brand-kit': 'Brand kit',
    voice: 'Voice',
};

export const KIND_ICON: Record<ReferenceKind, string> = {
    video: 'movie',
    template: 'auto_awesome_mosaic',
    blueprint: 'schema',
    'brand-kit': 'palette',
    voice: 'record_voice_over',
};

export const REFERENCE_KINDS: ReferenceKind[] = [
    'video',
    'blueprint',
    'template',
    'brand-kit',
    'voice',
];

export function isReferenceKind(value: string): value is ReferenceKind {
    return (REFERENCE_KINDS as string[]).includes(value);
}
